import React from 'react';
import { motion } from 'framer-motion';

const Tips = ({ language }) => {
  const tips = language === 'zh' ? [
    '在"我的寵物"中，紀錄從寵物加入家庭到現在的點點滴滴',
    '達成不同天數會獲得特殊的寵物成就和紀念徽章',
    '在"日期計算"中，你可以計算任意兩個日期之間的差異',
    '分享你和寵物的時光，留下美好的回憶'
  ] : [
    'In "My Pet", record your journey with your pet from the beginning until now',
    'Reach different milestones to unlock special pet achievements',
    'In "Date Calculator", you can calculate the difference between any two dates',
    'Share your journey with your pet and create beautiful memories'
  ];

  return (
    <motion.div 
      className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-5 mb-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <h3 className="font-medium text-gray-800 dark:text-gray-300 mb-3 flex items-center">
        <span className="emoji mr-2">💡</span>
        {language === 'zh' ? '小貼士' : 'Tips'}
      </h3>
      <ul className="list-disc pl-5 space-y-1.5 text-gray-600 dark:text-gray-400 text-sm">
        {tips.map((tip, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
          >
            {tip}
          </motion.li>
        ))}
      </ul>
    </motion.div>
  );
};

export default Tips;